import { IMAGE_CONFIG, IMAGE_LOADER, NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    inject,
    input,
    output,
} from '@angular/core';

import { LoaderParamsModel, MediaModel, imageOptimizeConfig } from '../../models/media.models';
import { ImageMediaService } from '../../services/image-media.service';
import { imageOptimizeLoader } from '../../services/img-loader-media.service';

import { CorePlatformService } from '@core/infrastructure/platform/platform.service';
import { WaterMarkComponent } from '@ui/watermark/watermark.component';

@Component({
    selector: '[media-image]',
    templateUrl: './media-image.component.html',
    imports: [
        NgOptimizedImage,
        WaterMarkComponent,
    ],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: { class: 'media-image' },
    providers: [
        ImageMediaService,
        {
            provide: IMAGE_LOADER,
            useValue: imageOptimizeLoader,
        },
        {
            provide: IMAGE_CONFIG,
            useValue: imageOptimizeConfig,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class MediaImageComponent implements OnInit {
    private readonly imageService = inject(ImageMediaService);

    private readonly platformService = inject(CorePlatformService);

    public loaderParams: LoaderParamsModel;

    public readonly isBrowser = this.platformService.isBrowser();

    // INPUT DATA
    public imageUrl = input.required<string>();

    public imageModel = input.required<MediaModel>();

    // OUTPUT EVENTS
    public readonly imageLoaded = output<Event>();

    public readonly imageError = output<Event>();

    public configShowWaterMark = false;

    public priorityLoad: boolean;

    public ngOnInit(): void {
        this.priorityLoad = this.imageModel()?.imagePriority;
        this.loaderParams = {
            hasAmandaSrc: this.imageService.hasAmandaSrc(this.imageUrl()),
            imageFormat: this.imageService.platformFormatImage(this.priorityLoad),
        };
    }

    public onImageLoad($event) {
        this.configShowWaterMark = this.imageService.getConfigWaterMark();
        this.imageLoaded.emit($event);
    }

    public onImageError($event) {
        console.warn(`Oops! The image you're looking for seems to have taken a detour. We couldn't find it (Error 404) in MediaImageComponent`);
        this.imageError.emit($event);
    }
}
